import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { TranslatableText, Translate } from '@dreryk/react-common';
import { StrongText, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../../../../../../../translations';

type PassportIdentityDocumentTextProps = {
   readonly identityDocument: IdentityDocument;
};

export const PassportIdentityDocumentText = (props: PassportIdentityDocumentTextProps): JSX.Element => {
   const type: TranslatableText = identityDocumentTranslationKeys.type.displayName.PASSPORT;
   const value: string = props.identityDocument.getSeriesAndNumber();

   return (
      <TextSeparator as={'span'} separator={TextSeparatorType.COLON_SPACE}>
         <Text testId={'identityDocumentType'}>
            <Translate>{type}</Translate>
         </Text>
         <StrongText testId={'identityDocumentValue'}>{value}</StrongText>
      </TextSeparator>
   );
};
